const isFloat = (s: string) => s.length > 0 && !isNaN(Number(s));

export default isFloat;
